import { render } from "./reviews.vue?vue&type=template&id=1a38c92a&scoped=true"
import script from "./reviews.vue?vue&type=script&lang=js"
export * from "./reviews.vue?vue&type=script&lang=js"

import "./reviews.vue?vue&type=style&index=0&id=1a38c92a&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a38c92a"]])

export default __exports__